import React from 'react';
import { Stack } from '@mui/material';
import LightboxDialog from '../../../components/LightboxDialog'; // Assuming path
import { IMS_FORM_IMG_PLACEHOLDER } from '../../../../../Constants'; // Assuming path

interface Component {
  label_display: any;
  label: any;
  photo_capture?: number;
  component_response?: { photo?: string };
}

interface IMSFormAccordionSubheadingProps {
  component: Component;
  setLightboxImage: (image: string | null) => void;
  setLightboxOpen: (open: boolean) => void;
}

const IMSFormAccordionSubheading: React.FC<IMSFormAccordionSubheadingProps> = ({
  component,
  setLightboxImage,
  setLightboxOpen,
}) => {
    const [lightboxOpen, setLocalLightboxOpen] = React.useState(false);
    const [lightboxImage, setLocalLightboxImage] = React.useState<string | null>(null);


    const handleImageClick = () => {
        if (component.component_response?.photo) {
            setLightboxImage(component.component_response.photo);
            setLightboxOpen(true);
        }
    };


  return (
    <>
      {component.photo_capture === 1 ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h4>{component.label_display || component.label}</h4>
          <Stack direction="row" spacing={2}>
            <img
              src={
                typeof component.component_response?.photo === 'string' &&
                component.component_response.photo.length > 0
                  ? component.component_response.photo
                  : IMS_FORM_IMG_PLACEHOLDER
              }
              alt="Thumbnail"
              style={{ width: 56, height: 56, cursor: 'pointer' }}
              onClick={handleImageClick}
            />
             {lightboxOpen && lightboxImage && (
                <LightboxDialog
                  open={lightboxOpen}
                  image={lightboxImage}
                  onClose={() => setLightboxOpen(false)}
                />
              )}
          </Stack>
        </div>
      ) : (
        <h4>{component.label_display || component.label}</h4>
      )}
    </>
  );
};

export default IMSFormAccordionSubheading;